<template>
  <div class="page-content rules">
    <h1 class="page-title">{{ $locale("sideMenu.performance.priceRuleTemplate") }}</h1>

    <el-row class="search-area">
      <el-col  class="makeInline" :lg="16" :md="16" :sm="24">
        <el-input :placeholder="$locale('form.plsEnterYourName')" v-model="filter.name" @keyup.enter.native="searchFn" class="searchMaxWidth">
          <i slot="suffix" class="el-input__icon el-icon-search" @click="searchFn"></i>
        </el-input>
        <el-button class="egl-btn-yellow makeLeft" @click="searchFn">{{ $locale("global.search") }}</el-button>
      </el-col>
      <el-col  class="ta-r" :lg="8" :md="8" :sm="24">
        <el-button class="egl-btn-yellow" @click="toDetail('create')">{{ $locale('rules.createRule') }}</el-button>
      </el-col>
    </el-row>

    <el-table :data="ruleList" class="egl-table" stripe>
      <el-table-column type="index" label="" min-width="20%" ></el-table-column>
      <el-table-column prop="name" type='' :label="$locale('global.name')" ></el-table-column>
      <el-table-column align="center" min-width="20%">
        <template slot="header">{{ $locale("global.control") }}</template>
        <template slot-scope="scope">
          <div class="handle">
            <a @click="toDetail('edit', scope.$index)">{{ $locale("global.edit") }}</a>
            <el-divider direction="vertical"></el-divider>
            <a @click="deleteRule_fn(scope.$index)">{{ $locale("global.delete") }}</a>
          </div>
        </template>
      </el-table-column>
    </el-table>

    <CommPagination
      :total="pageCount"
      :curPage="onSearch.page"
      :pageSize="onSearch.pageSize"
      @current-change="choosePage"
    />

  </div>
</template>
<style scoped>
.searchMaxWidth{
  max-width: 350px;
  margin-right: 5px;
}
.makeLeft {
  margin-left: 5px;
}
.makeInline {
  white-space:nowrap;
}
.el-col {
  margin-bottom: 5px;
}
</style>
<script>
import "@/assets/style/rulesTemplate.less";
import { rulesList } from "@/helpers/service/api/common.js";
import countDownAlert from "@/utils/countDownAlert";
import { deleteRule } from "@/helpers/service/api/rules.js";
import CommPagination from "@/components/common/CommPagination";

export default {
  name: "rules",
  data() {
    return {
      onSearch: {
        name: "",
        status: "active",
        page: 0,
        pageSize: 10,
      },
      filter: {
        name: "",
      },
      statusOptions: [
        {
          value: "",
          label: this.$locale("global.all"),
        },
        {
          value: "active",
          label: this.$locale("global.active"),
        },
        {
          value: "delete",
          label: this.$locale("global.delete"),
        },
        {
          value: "inactive",
          label: this.$locale("global.inactive"),
        },
      ],
      ruleList: [],
      pageCount: 0,
    };
  },
  mounted() {
    const cinemaId = window.localStorage.getItem("cinemaId") || "";

    if (cinemaId == "") {
      this.$emit("callCinema", "getData");

      return;
    }

    this.getData();
  },
  methods: {
    getData() {
      let cinemaId = window.localStorage.getItem("cinemaId");
      let params = {
        ...this.onSearch,
        cinemaId: cinemaId,
      };

      rulesList(params).then(res => {
        if (res.success) {
          this.ruleList = [ ...res.data.data ];
          // this.pageCount = Math.ceil(res.data.count / this.onSearch.pageSize);
          this.pageCount = res.data.count || 0;
        }
      }).catch(() => {});
    },
    choosePage(page) {
      this.onSearch = {
        ...this.onSearch,
        page: page - 1,
      };

      this.getData();
    },
    searchFn() {
      this.onSearch = {
        ...this.onSearch,
        ...this.filter,
        page: 0,
      };

      this.getData();
    },
    toDetail(act = "create", index = 0) {
      if (act == "create") {
        this.$router.push({ path: "/rules/create" });
      } else {
        this.$router.push({ path: `/rules/edit/${this.ruleList[index].id}` });
      }
    },
    deleteRule_fn(index) {
      const that = this;
      const ruleName = that.ruleList[index].name;
      const ruleId = that.ruleList[index].id;
      const confirmHtml = `
        <i class="egl-confirm-question">?</i>
        <span class="result-text">${this.$locale("global.delete")} ${ruleName}</span>`;

      this.$confirm(confirmHtml, "", {
        dangerouslyUseHTMLString: true,
        showClose: false,
        showCancelButton: true,
        cancelButtonClass: "egl-btn-white",
        cancelButtonText: this.$locale("global.cancel"),
        showConfirmButton: true,
        confirmButtonClass: "egl-btn-yellow",
        confirmButtonText: this.$locale("global.delete"),
        customClass: "egl-confirm",
        closeOnClickModal: false,
      }).then(() => {
        // confirm
        deleteRule({ id: ruleId }).then(res => {
          if (res.success) {
            countDownAlert({
              content: this.$locale("global.deleteSuccessfully"),
              callback: () => {
                that.getData();
              }
            });
          }
        });
      });
    },
  },
  components: {
    CommPagination,
  },
};
</script>
